import { Environment } from '@approvalmax/types';

export const getAuthenticatedCookieKey = (environment: Environment) => {
    if (environment === 'production') return 'authenticated';

    return `authenticated-${environment}`;
};
